import React from 'react';
import styles from './styles.module.scss';

import StyledLink from 'components/StyledLink';
import { FormServerAssetSearch } from 'components/FormComponents';

import { FormProvider, useForm } from 'react-hook-form';

import { ASSET_DETAILED_PATH } from 'constants/routeConstants';

import EditableContent from '../EditableContent';

export default function DrCodeCellContent({ row, onEdit, isEditable }) {
  const { asset, itemName } = row;

  const methods = useForm({
    defaultValues: {
      asset
    }
  });
  const { setValue, getValues } = methods;

  const setDefaultValue = () => setValue('asset', asset);

  const selectAsset = (name, value) => setValue(name, value);

  const handleAcceptClick = () => {
    onEdit({ ...row, asset: getValues('asset') });
  };

  return (
    <EditableContent
      onAccept={handleAcceptClick}
      isEditable={isEditable}
      setDefaultValue={setDefaultValue}
      renderDisplayedComponent={() => (
        <StyledLink
          to={`${ASSET_DETAILED_PATH}/${asset.id}`}
          isRedirectAvailable={!!asset?.id}
          className={styles.drCode__link}>
          {itemName || ''}
        </StyledLink>
      )}
      renderEditor={() => (
        <FormProvider {...methods}>
          <FormServerAssetSearch
            name="asset"
            getLabel={(option) => option?.drCode || ''}
            getQuery={(searchQuery) => ({
              pagination: { limit: 39, page: 1 },
              filters: { isDeleted: false, picklistAssetId: row?.id, searchQuery }
            })}
            onSelect={selectAsset}
            className={styles.drCode__field}
          />
        </FormProvider>
      )}
    />
  );
}
